import { connectListView, ListView } from "../../../UI/view/list-view";
import { liquidBillingAutomaticDS, liquidBillingCreditDS } from "./liquid-billing-datasource";
import { CreateTransfer, CreateTransferDataSource } from "./liquid-create-transfer";
import { liquidBillingListColumns, liquidBillingListToolbar, liquidListFilters } from "./liquid-invoice-list";

export const liquidBillingAutomaticList = {
  name: 'liquidBillingAutomaticList',
  filters: liquidListFilters,
  columns: liquidBillingListColumns,
  additionalModals: [
    {
      form: CreateTransfer,
      repository: CreateTransferDataSource,
      name: 'createTransfer',
      title: 'Create Transfer',
    }
  ],
  toolbar: liquidBillingListToolbar('liquidBillingAutomaticList'),
} as ListView;


export const [LiquidBillingAutomaticList, LiquidBillingInvoiceAutomaticDataSource] = connectListView(liquidBillingAutomaticList, liquidBillingAutomaticDS);